import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { requestApp, WEB_TO_APP } from "common/webview";
import { clearAuth } from "common/auth";
import './Withdraw.css';

export const WithdrawDone = () => {
    const { t } = useTranslation();

    useEffect(() => {
        // webview 측 in-memory 토큰 정리 (native MMKV 토큰은 native가 별도 정리)
        clearAuth();

        // 1.5초간 완료 메시지 노출 후 네이티브에 통지 (네이티브가 모달 정리 + Main 이동)
        const timer = setTimeout(() => {
            requestApp(WEB_TO_APP.WITHDRAW_DONE);
        }, 1500);
        return () => clearTimeout(timer);
    }, []);

    return (
        <div className="withdraw-done">
            <span className="withdraw-done-title">{t("withdraw.done.title")}</span>
            <span className="withdraw-done-message">{t("withdraw.done.message")}</span>
        </div>
    );
};
